import {useContext, useEffect, useRef} from 'react'
import {SectionSearchBarContext} from './SearchBar'
import {connectService} from 'components/service/connectService'
import {Group} from './CreateGroup'
import {useNavigate, useParams} from 'react-router-dom'
import { Tooltip } from 'react-tooltip'

export const Groups = connectService(
  props => {
    const navigate = useNavigate()
    const groupModalRef = useRef(null)
    const {distributor, reseller, business} = useParams()

    const {skip, total, limit, list, loading, Loader, Placeholder, Paginator, allowActions, onCreated} = props
    const {setPlaceholder} = useContext(SectionSearchBarContext)

    useEffect(() => {
      setPlaceholder(`Showing ${skip + 1} to ${skip + limit} of ${total}`)
    }, [limit, setPlaceholder, skip, total])

    const onEdit = group => {
      navigate(`group/${group._id}`)
    }

    return (
      <div className="table-responsive">
        <table className="vw-table vw-tab-table">
          <thead>
            <tr>
              <th>Group name</th>
              <th>Devices</th>
              <th>People</th>
              <th colSpan="2"></th>
            </tr>
          </thead>
          <tbody>
            {list.length ? (
              list.map(item => (
                <tr key={item._id}>
                  <td>
                    <div className="vw-table__name">
                      {item.name}
                      <small className="ml-3" data-tooltip-id={`rotation-${item._id}-interval`}>
                        <i className="fal fa-sync-alt"></i>
                        {item?.rotationInterval || 30 }
                      </small>
                      <Tooltip
                          id={`rotation-${item._id}-interval`}
                          place="left"
                          content={`Rotates at ${item?.rotationInterval || 30} minutes interval`}
                        />
                    </div>
                  </td>

                  <td>
                    <ul className="vw-table__admins">
                      <li data-tooltip-id={`statistics-${item._id}-devices`}>
                      { item?.statistics?.devices || 0 } <i className="fal fa-desktop"></i>
                        <Tooltip
                          id={`statistics-${item._id}-devices`}
                          place="left"
                          content={`${item?.statistics?.devices} Devices`}
                        />
                      </li>
                    </ul>
                  </td>

                  <td>
                    <ul className="vw-table__details">
                      <li data-tooltip-id={`statistics-${item._id}-remotes`}>
                        { item?.statistics?.remotes || 0 } <i className="fal fa-user-cog"></i>
                        <Tooltip
                          id={`statistics-${item._id}-remotes`}
                          place="left"
                          content={`${item?.statistics?.remotes} Remote User(s)`}
                        />
                      </li>
                    </ul>
                  </td>
                  <td colSpan="2" className="text-right">
                    <button className="btn btn-primary edit" onClick={() => onEdit(item)}>
                      View/Edit
                    </button>
                  </td>
                </tr>
              ))
            ) : loading ? (
              <Loader colSpan="4" />
            ) : (
              <Placeholder placeholder="No Groups" colSpan="4" />
            )}
          </tbody>
        </table>
        <Group ref={groupModalRef} onCreated={onCreated} />

        <div className="vw-group-button">
          <button
            className="btn btn-add btn-add--lg vw-tab-group-button"
            onClick={() => {
              const payload = {business}
              if (distributor) {
                payload.distributor = distributor
              }

              if (reseller) {
                payload.reseller = reseller
              }

              groupModalRef.current.show(payload)
            }}
          >
            <i className="fal fa-plus"></i>
          </button>
        </div>

        {
          Paginator({
            className: 'd-flex flex-row-reverse mt-2',
            sm: true
          })
        }
      </div>
    )
  },
  'group',
  {
    query: {
      $sort: {name: 1}
    },
    paramsAsQueryParams: ['distributor', 'reseller', 'business']
  }
)
